import React from "react";
import { Link } from "react-router-dom";

function EAIVisionCaseStudies() {
  // Example list of EAIVision case studies
  const caseStudies = [
    { id: 1, title: "EMR", path: "/EMR" },

  ];

  return (
    <div style={{ padding: "20px" }}>
      <h1>EAIVision Case Studies</h1>
      <ul style={{ listStyle: "none", padding: 0 }}>
        {caseStudies.map((cs) => (
          <li key={cs.id} style={{ margin: "10px 0" }}>
            <Link
              to={cs.path}
              style={{
                textDecoration: "none",
                color: "#007bff",
                fontSize: "18px",
              }}
            >
              {cs.title}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default EAIVisionCaseStudies;
